/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type PlanningProposalsFilterStatusItem =
  (typeof PlanningProposalsFilterStatusItem)[keyof typeof PlanningProposalsFilterStatusItem];

export const PlanningProposalsFilterStatusItem = {
  IDEA_PHASE: "IDEA_PHASE",
  ADOPTED: "ADOPTED",
  POSTPONED: "POSTPONED",
  STARTED: "STARTED",
  SUGGESTION: "SUGGESTION",
  CANCELLED: "CANCELLED",
  UNKNOWN: "UNKNOWN",
} as const;
